import React from "react";
import { NavLink } from "react-router-dom";
import { FaBlog, FaImages, FaBoxOpen, FaTools } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";

import { IoMenu } from "react-icons/io5";
import { BiSolidDashboard } from "react-icons/bi";
import { MdOutlineEditAttributes } from "react-icons/md";
import { FaQuestion } from "react-icons/fa";
import { GiTeamIdea } from "react-icons/gi";
import { LuMilestone } from "react-icons/lu";


const Sidebar = ({ handleSidebarClose, customClass }) => {
  const navigate = useNavigate();
  return (
    <aside className={`sidenav ${customClass}`}>


      <div className="sidenav-header d-flex justify-content-between align-items-center px-3">

        <img src="/Images/logo.png" alt="logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }} />


        <button
          className="btn p-0 d-lg-none"
          onClick={handleSidebarClose}
          aria-label="Close sidebar"
        >
          <RxCross2 color="#fff" size={22} />
        </button>
      </div>


      <ul className="navbar-nav">
        <li className="nav-item">
          {/* <NavLink
            to="/"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <BiSolidDashboard className="nav-icon mx-2" />
            <span className="nav-link-text">Dashboard</span>
          </NavLink> */}
        </li>
        <li className="nav-item">
          <NavLink
            to="/menu"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <IoMenu className="nav-icon mx-2" />
            <span className="nav-link-text">Menu</span>
          </NavLink>
        </li>
        {/* <li className="nav-item">
          <NavLink
            to="/home"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <AiFillHome className="nav-icon mx-2" />
            <span className="nav-link-text">Home</span>
          </NavLink>
        </li> */}

        <li className="nav-item">
          <NavLink
            to="/services"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <FaTools className="nav-icon mx-2" />
            <span className="nav-link-text">Services</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/blog"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <FaBlog className="nav-icon mx-2" />
            <span className="nav-link-text">Blog</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/gallery"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <FaImages className="nav-icon mx-2" />
            <span className="nav-link-text">Gallery</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/category"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <FaBoxOpen className="nav-icon mx-2" />
            <span className="nav-link-text">CategoryList</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/faq"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <FaQuestion className="nav-icon mx-2" />
            <span className="nav-link-text">FAQ</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/contact-list"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <GiTeamIdea size={22} className="nav-icon mx-2" />
            <span className="nav-link-text">Contact List</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/magnus-team"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <GiTeamIdea size={22} className="nav-icon mx-2" />
            <span className="nav-link-text">Magnus Team</span>
          </NavLink>
        </li>

        <li className="nav-item">
          <NavLink
            to="/milestone"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <LuMilestone size={22} className="nav-icon mx-2" />
            <span className="nav-link-text">MileStone</span>
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="/attribute"
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            onClick={handleSidebarClose}
          >
            <MdOutlineEditAttributes size={22} className="nav-icon mx-2" />
            <span className="nav-link-text">Attribute</span>
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
